(function () {
  if (window.WyrdCartPage && typeof window.WyrdCartPage.initAll === 'function') {
    window.WyrdCartPage.initAll();
    return;
  }

  var refreshInFlight = false;
  var countdownTimer = null;
  var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function addBizDays(count, from) {
    var date = new Date(from);
    var added = 0;
    while (added < count) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return monthNames[date.getMonth()] + ' ' + pad(date.getDate()) + ', ' + date.getFullYear();
  }

  function getRoot(scope) {
    var rootId = scope && scope.dataset.wsCartRootId;
    return rootId ? document.getElementById(rootId) : null;
  }

  function getScope(root) {
    return root && root.querySelector('[data-ws-cart-page]');
  }

  function tick(root) {
    var scope = getScope(root);
    if (!scope) return;

    var now = Date.now();
    var cutoff = new Date(now);
    cutoff.setUTCHours(8, 0, 0, 0);
    if (cutoff.getTime() <= now) cutoff.setUTCDate(cutoff.getUTCDate() + 1);

    var remaining = Math.max(0, Math.floor((cutoff.getTime() - now) / 1000));
    var hours = root.querySelector('[data-ws-cart-hours]');
    var minutes = root.querySelector('[data-ws-cart-minutes]');
    var seconds = root.querySelector('[data-ws-cart-seconds]');
    var batchDate = root.querySelector('[data-ws-cart-batch-date]');
    var arrival = root.querySelector('[data-ws-cart-arrival]');
    var deliveryDays = parseInt(scope.dataset.wsCartDeliveryBusinessDays || '12', 10);

    if (hours) hours.textContent = pad(Math.floor(remaining / 3600));
    if (minutes) minutes.textContent = pad(Math.floor((remaining % 3600) / 60));
    if (seconds) seconds.textContent = pad(remaining % 60);
    if (batchDate) batchDate.textContent = addBizDays(2, cutoff);
    if (arrival) arrival.textContent = 'Arrives around ' + addBizDays(deliveryDays, new Date());
  }

  function startCountdown(root) {
    if (countdownTimer) window.clearInterval(countdownTimer);
    tick(root);
    countdownTimer = window.setInterval(function () {
      tick(root);
    }, 1000);
  }

  function setLoading(root, loading) {
    var scope = getScope(root);
    if (scope) scope.dataset.wsCartLoading = loading ? 'true' : 'false';
  }

  function showError(root, message) {
    var errorNode = root && root.querySelector('#cart-errors');
    if (errorNode) errorNode.textContent = message || '';
  }

  function getErrorMessage(response, fallback) {
    if (!response) return fallback;
    return response.description || response.message || response.status || fallback;
  }

  function replaceHeaderCart(doc) {
    var currentBubble = document.getElementById('cart-icon-bubble');
    var nextBubble = doc.getElementById('cart-icon-bubble');
    if (currentBubble && nextBubble) currentBubble.replaceWith(nextBubble);
  }

  async function refreshCartSection(root) {
    var scope = getScope(root);
    if (!scope) return;

    var currentRoot = getRoot(scope);
    if (!currentRoot) return;

    var url = new URL(window.location.href);
    url.hash = '';

    var response = await fetch(url.toString(), {
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) throw new Error('Could not refresh cart.');

    var html = await response.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nextRoot = doc.getElementById(scope.dataset.wsCartRootId);
    if (!nextRoot) throw new Error('Could not refresh cart.');

    var currentExpress = currentRoot.querySelector('.ws-cart-express.additional-checkout-buttons');
    var nextExpress = nextRoot.querySelector('.ws-cart-express.additional-checkout-buttons');
    if (currentExpress && nextExpress) nextExpress.replaceWith(currentExpress);

    replaceHeaderCart(doc);
    currentRoot.replaceWith(nextRoot);
    initAll();
  }

  async function requestCartUpdate(root, url, options) {
    if (refreshInFlight) return;
    refreshInFlight = true;
    setLoading(root, true);
    showError(root, '');

    try {
      var response = await fetch(url, options);
      var payload = null;
      try {
        payload = await response.clone().json();
      } catch (error) {
        payload = null;
      }

      if (!response.ok) {
        throw new Error(getErrorMessage(payload, 'Cart could not be updated.'));
      }

      await refreshCartSection(root);
    } catch (error) {
      var freshRoot = getRoot(getScope(root)) || root;
      showError(freshRoot, error.message || 'Cart could not be updated.');
      setLoading(freshRoot, false);
    } finally {
      refreshInFlight = false;
      var currentScope = document.querySelector('[data-ws-cart-page]');
      var currentRoot = getRoot(currentScope);
      if (currentRoot) setLoading(currentRoot, false);
    }
  }

  function handleQuantityLink(event, root) {
    var link = event.target.closest('.ws-cart-qty a, .ws-cart-remove');
    if (!link || !root.contains(link)) return false;

    var url = new URL(link.href, window.location.origin);
    if (!url.pathname.includes('/cart/change')) return false;

    event.preventDefault();
    link.setAttribute('aria-busy', 'true');

    var scope = getScope(root);
    var body = new URLSearchParams();
    body.set('line', url.searchParams.get('line') || '');
    body.set('quantity', url.searchParams.get('quantity') || '0');

    requestCartUpdate(root, scope.dataset.wsCartChangeUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    });

    return true;
  }

  function handleUpsellSubmit(event, root) {
    var form = event.target.closest('form');
    if (!form || !root.contains(form)) return false;

    var action = new URL(form.action, window.location.origin);
    if (!action.pathname.includes('/cart/add')) return false;

    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    if (button) button.setAttribute('aria-busy', 'true');

    var scope = getScope(root);
    var formData = new FormData(form);
    formData.delete('return_to');

    requestCartUpdate(root, scope.dataset.wsCartAddUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    });

    return true;
  }

  function initRoot(root) {
    if (!root || root.dataset.wsCartAjaxInit === 'true') {
      if (root) startCountdown(root);
      return;
    }

    root.dataset.wsCartAjaxInit = 'true';
    root.addEventListener('click', function (event) {
      handleQuantityLink(event, root);
    });
    root.addEventListener('submit', function (event) {
      handleUpsellSubmit(event, root);
    });
    startCountdown(root);
  }

  function initAll() {
    var scopes = document.querySelectorAll('[data-ws-cart-page]');
    scopes.forEach(function (scope) {
      initRoot(getRoot(scope));
    });
  }

  window.WyrdCartPage = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
